import './init_Jquery';


// Because of JS import hoisting, we need this init code to be here,
// so that following imports in application.js have access to `bootstrap`

import Rails from '@rails/ujs';
// rails-ujs
window.Rails = Rails
Rails.start();

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import toastr from 'toastr';
window.toastr = toastr;

import Glide from '@glidejs/glide';
window.Glide = Glide;

import 'intl-tel-input/build/js/intlTelInput-jquery';

import './mobile_profile_nav';
import './subscription_expiration';
import './cable';
import './input_files';
import './subscribe_modal';
import './users/profile';
import './users/password_toggle';
import './users/payins';
import './projects/index';
import './autocomplete_address';
import './accept_distributor_modal';

// Stimulus
import './controllers';

$(function () {
  $('.auto-input').on('change', function () {
    var form = $(this).parents('form')[0];
    Rails.fire(form, 'submit');
  });

  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle=\'tooltip\']'),
  );
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    new bootstrap.Tooltip(tooltipTriggerEl);
  });
});
